import notify from '@/api/notification'
import userManagementService from '@/api/userManagement'

const state = {
  teamList: [],
  actualMember: null,
  loadingStatus: 'STOPPED',
}

const mutations = {
  updateTeamList(state, data) {
    state.teamList = data
  },
  updateActualMember(state, data) {
    console.info(data)
    state.actualMember = data
  },
  setLoadingStatus(state, status) {
    state.loadingStatus = status
  },
}

const getters = {
  teamList: state => {
    return state.teamList
  },
  actualMember: state => {
    return state.actualMember
  },
  loadingStatus: state => {
    return state.loadingStatus
  },
}

const actions = {
  getTeamList: ({ commit }) => {
    commit('setLoadingStatus', 'LOADING')
    return userManagementService
      .getMemberList()
      .then(res => {
        let list = res.data
        list.forEach(item => {
          const role = item.role
          item.label = insertPortugueseLabel(role)
        })
        commit('updateTeamList', list)
        commit('setLoadingStatus', 'STOPPED')
      })
      .catch(err => {
        commit('setLoadingStatus', 'STOPPED')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar lista de membros.',
        })
        console.log('err -->', err)
      })
  },
  getOperatorInfo: ({ commit }, id) => {
    commit('setLoadingStatus', 'LOADING')
    return userManagementService
      .getMemberById(id)
      .then(res => {
        commit('updateActualMember', res.data)
        commit('setLoadingStatus', 'STOPPED')
      })
      .catch(err => {
        commit('setLoadingStatus', 'STOPPED')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar dados da conta.',
        })
        console.log('err -->', err)
      })
  },
}

const insertPortugueseLabel = role => {
  if (role === 'OPERATOR') {
    return 'OPERADOR'
  }
  if (role === 'FINANCIAL') {
    return 'FINANCEIRO'
  }
  if (role === 'REGISTER') {
    return 'CADASTRO'
  }
  return role
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
